import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function suggestSpecialties(payload) {
  const query = payload?.query || payload?.symptom || payload?.sintoma || '';
  try {
    const response = await axios.post(`${API_URL}/api/specialties/suggest`, {
      ...payload,
      client: payload.client || 'web',
    });
    return response.data;
  } catch (error) {
    if (!query.trim()) {
      throw error;
    }
    const response = await axios.post(`${API_URL}/api/public/analyze-symptoms`, {
      symptoms: query.trim(),
    });
    const data = response.data || {};
    return {
      analysis: {
        source: data.source || '',
        fallbackUsed: data.source !== 'llm',
        query: query.trim(),
      },
      suggestedSpecialties: data.suggestions || [],
      safetyAlert: {
        isUrgency: Boolean(data.red_flags?.length),
        message: data.red_flags?.[0] || data.safety_note || '',
      },
      nextStep: {
        action: 'USER_SELECT_SPECIALTY',
        message: data.next_steps?.[0] || 'Selecione uma das especialidades sugeridas para buscar médicos disponíveis.',
      },
    };
  }
}

export async function searchDoctors(payload) {
  const response = await axios.post(`${API_URL}/api/doctors/search`, {
    ...payload,
    client: payload.client || 'web',
  });
  return response.data;
}

export async function searchProviders(payload) {
  if (payload?.selectedSpecialty || payload?.specialty || payload?.specialty_id) {
    return searchDoctors(payload);
  }
  return suggestSpecialties(payload);
}

export async function getSpecialtyCitySeoPage(specialtySlug, cityUf, params = {}) {
  const response = await axios.get(`${API_URL}/api/public/seo/specialists/${specialtySlug}/${cityUf}`, {
    params,
  });
  return response.data;
}
